import React from "react";
import BrandLogo from "./brand-logo";

const FILLED_MARKS = [
    {
        width: "min(23vw, 25vh)",
        height: "min(23vw, 25vh)",
        top: "-6vh",
        left: "-5vw",
        opacity: 0.022,
    },
    {
        width: "min(9vw, 11vh)",
        height: "min(9vw, 11vh)",
        top: "12vh",
        left: "42vw",
        opacity: 0.018,
    },
    {
        width: "min(11vw, 13vh)",
        height: "min(11vw, 13vh)",
        top: "44%",
        left: "18vw",
        opacity: 0.027,
    },
    {
        width: "min(40vw, 40vh)",
        height: "min(40vw, 40vh)",
        left: "-10vw",
        bottom: "-10vh",
        opacity: 0.05,
    },
    {
        width: "min(18vw, 19vh)",
        height: "min(18vw, 19vh)",
        right: "9vw",
        top: "48%",
        transform: "translateY(-50%)",
        opacity: 0.032,
    },
    {
        width: "min(20vw, 20vh)",
        height: "min(20vw, 20vh)",
        right: "-5vw",
        bottom: "-5vh",
        opacity: 0.024,
    },
    {
        width: "min(12vw, 14vh)",
        height: "min(12vw, 14vh)",
        left: "53vw",
        bottom: "10vh",
        opacity: 0.038,
    },
];

function OutlineBrandMark() {
    return (
        <svg
            className="absolute"
            style={{
                width: "min(40vw, 40vh)",
                height: "min(40vw, 40vh)",
                top: "-10vh",
                right: "-10vw",
                opacity: 0.042,
            }}
            viewBox="0 0 100 100"
            fill="none"
            aria-hidden="true"
        >
            <rect x="8" y="8" width="84" height="84" rx="35" stroke="#E6511C" strokeWidth="1.4"/>
            <rect x="25" y="25" width="50" height="50" rx="21" stroke="#E6511C" strokeWidth="1.4"/>
            <rect x="40" y="40" width="20" height="20" rx="8" stroke="#E6511C" strokeWidth="1.4"/>
        </svg>
    );
}

function AuthBrandPattern() {
    return (
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" aria-hidden="true">
            <OutlineBrandMark/>
            {FILLED_MARKS.map((position, index) => (
                <BrandLogo
                    key={index}
                    variant="mark"
                    alt=""
                    className="absolute"
                    style={position}
                />
            ))}
        </div>
    );
}

export default AuthBrandPattern;
